<template>
  <div class="row form">
    <button
      class="btn button"
      data-bs-toggle="modal"
      data-bs-target="#asistenteiamodal"
      style="margin-top: 20pt"
      :style="{ backgroundColor: '#003aff' }"
      @click="getResultadosAsistenteIa"
    >
      {{ $t("mUser.ocases.asistenteia") }}
    </button>
  </div>

  <!-- Modal Asistente ia -->
  <div
    class="modal fade"
    id="asistenteiamodal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ $t("mUser.ocases.asistenteia") }}
          </h5>
          <button
            @click="deia_pregunta = ''"
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div v-if="isLoading" class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <div class="px-4 py-3" v-else>
            <div class="col">
              <div class="card" id="cardForm">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">{{ $t("mUser.ocases.date") }}</th>
                  <th scope="col">{{ $t("mUser.ocases.question") }}</th>
                  <th scope="col">{{ $t("mUser.ocases.answer") }}</th>
                </tr>
              </thead>
              <tbody style="text-align: justify">
                <tr v-for="(item, index) in preres">
                  <td style="width: 50px;">{{ index+1 }}</td>
                  <td style="width: 20%;">
                    {{ item.deia_fecha ? formatFecha(item.deia_fecha) : '' }}
                  </td>
                  <td>{{ item.deia_texto }}</td>
                  <td>{{ item.deia_respuesta }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div>
            <p>{{ $t('legal.asistenteIa') }}</p>
          </div>
          </div>
            <!-- NUEVA PREGUNTA -->
            <div class="col mt-5" v-if="showForm">
              <div class="row align-items-end">
                <div class="col">
                  <label class="form-label">{{
                    $t(`mUser.ocases.newPregunta`)
                  }}</label>
                  <textarea
                  v-model.trim="deia_pregunta"
                  class="form-control"
                  rows="3"
                  maxlength="500"
                  />
                </div>
                <div class="col-md-4 text-center">
                  <button
                    type="button"
                    class="btnCrud"
                    @click="sendPreguntaIa()"
                    :style="{ backgroundColor: colorCompany || '#e99417' }"
                    :disabled="deia_pregunta == '' ? true : false"
                  >
                    {{ $t("actions.send") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import axios from "axios";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "AsistenteIAUser",
  data() {
    moment.locale("es");
    return {
      preres: [], //Preguntas respuestas (resultados)
      deia_pregunta: '',
      isLoading: false,
    };
  },
  computed: {
    ...mapState(["colorCompany", "servidor"]),
    showForm: function () {
      return !!this.preres && this.preres.length == 5 ? false : true;
    }
  },
  props: ['denuItem'],
  methods: {
    formatFecha(fecha) {
      return moment(fecha).format('DD/MM/YYYY HH:mm');
    },
    async sendPreguntaIa() {
      try {
        this.isLoading = true;
        const res = await axios.post(
          `${this.servidor}api/op_denuncia.asp?tp=analisis&ac=grabarasistenteia`, 
          {
            denu_id: this.denuItem.denu_id, 
            deia_texto: this.deia_pregunta, 
          }
        );
        this.deia_pregunta = '';
        if(res.data.RESULT){
          if(res.data.RESULT == 0){
            this.getResultadosAsistenteIa();
          }
          // this.$emit('actualizar-result', res.data.RESULT)
        }
        this.isLoading = false;
      } catch (error) {
        console.error(error);
      }
    },
    async getResultadosAsistenteIa() {
      try {
        this.deia_pregunta = '';
        const res = await axios.get(
          `${this.servidor}api/op_denuncia.asp?tp=analisis&ac=asistenteia&denu_id=${this.denuItem.denu_id}`
        );
        if (res.data){
          this.preres = res.data.data;
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
}
</script>